<!-- detached layout -->
@if ((authService.isAuthenticated | async) && (authService.isAuthenticated$ | async)) {
  <app-detached-layout>
  </app-detached-layout>
}

<!-- right sidebar-->
<div class="rightbar-overlay"></div>
<app-ui-offline-modal></app-ui-offline-modal>
